export const eventInitialState = {
    projectList: []
};